const parameterPattern = /{{([^}]+)}}/g;

/**
 * @description This function makes replacement inside string with templates values
 * @param {string} tpl
 * @param {Object<string, string|number>} ctx
 * @returns {string}
 */

export default function interpolate(tpl = '', ctx) {
  const replacer = function (match, parameterId) {
    if (ctx.hasOwnProperty(parameterId)) {
      return ctx[parameterId] ?? '';
    }

    // throw new Error(`Passed context does not contain required property "${parameterId}"`);
    return match;
  };
  return tpl.replace(parameterPattern, replacer);
}
